function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, HStack, Icon, IconButton, Switch, Td, Text, Tr, useDisclosure, ButtonGroup, Th, Stack } from '@chakra-ui/react';
import Heading from '@/components/Heading';
import Table from '@/components/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPencil, faPlus } from '@fortawesome/free-solid-svg-icons';
import InputModal from '@/components/InputModal';
import useTimerStore from '@/stores/TimerStore';
import { deleteTimer, getTimers, updateTimer } from '@/actions/TimerActions';
import cronstrue from 'cronstrue';
import useChannelStore from '@/stores/ChannelStore';
import TableHeading from '@/components/TableHeading';
import AliasResponse from '@/components/AliasResponse';
import { useLimitQueryState, usePageQueryState, useSearchQueryState, useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import { LordIconSizes, SortDirections } from '@/types/client';
import SearchInput from '@/components/SearchInput';
import EmptyState from '@/components/EmptyState';
import useQueryState from '@/hooks/useQueryState';
import DashboardLayout from '../layouts/DashboardLayout';
import { FormattedMessage, useIntl } from 'react-intl';
import Pagination from '../Pagination';
import { useNavigate } from 'react-router';
import { DynamicWebRoutes, WebRoutes } from '@/utils/constants';
import Alarm from '../icons/lord/Alarm';
import { Helmet } from 'react-helmet';
import { useShallow } from 'zustand/react/shallow';
import { useDebounce } from 'use-debounce';
var HeadingKeys;
(function(HeadingKeys) {
    HeadingKeys["ENABLED"] = "enabled";
    HeadingKeys["NAME"] = "name";
})(HeadingKeys || (HeadingKeys = {}));
var _obj;
var SortFunctions = (_obj = {}, _define_property(_obj, "enabled", function(a, b) {
    return Number(a.enabled) - Number(b.enabled);
}), _define_property(_obj, "name", function(a, b) {
    return a.name.localeCompare(b.name);
}), _obj);
function TimerHeader(param) {
    var sortBy = param.sortBy, sortDirection = param.sortDirection, setSortDirection = param.setSortDirection, setSortBy = param.setSortBy;
    function handleSortChange(key, direction) {
        setSortDirection(direction);
        setSortBy(direction != null ? key : null);
    }
    return /*#__PURE__*/ _jsxs(Tr, {
        children: [
            /*#__PURE__*/ _jsx(TableHeading, {
                active: sortBy === "enabled",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("enabled", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "V52jNn",
                    defaultMessage: "Enabled"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                active: sortBy === "name",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("name", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "ju5mki",
                    defaultMessage: "Timer"
                })
            }),
            /*#__PURE__*/ _jsx(Th, {
                display: {
                    base: 'none',
                    md: 'table-cell'
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "6m3w+3",
                    defaultMessage: "Interval"
                })
            }),
            /*#__PURE__*/ _jsx(Th, {
                textAlign: "right",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "wL7VAE",
                    defaultMessage: "Actions"
                })
            })
        ]
    });
}
var MemoizedTimerHeader = /*#__PURE__*/ React.memo(TimerHeader);
function TimerRow(param) {
    var timer = param.timer, channel = param.channel, parentOnDelete = param.onDelete, parentOnEdit = param.onEdit;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var onDelete = React.useCallback(function() {
        return parentOnDelete(timer._id);
    }, [
        parentOnDelete,
        timer._id
    ]);
    var onEdit = React.useCallback(function() {
        return parentOnEdit(timer._id);
    }, [
        parentOnEdit,
        timer._id
    ]);
    var handleToggleEnabled = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if ((channel === null || channel === void 0 ? void 0 : channel._id) != null) {
                setLoading(true);
                updateTimer(channel._id, _object_spread_props(_object_spread({}, timer), {
                    enabled: !timer.enabled
                })).finally(function() {
                    return setLoading(false);
                });
            }
            return [
                2
            ];
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        timer,
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    return /*#__PURE__*/ _jsxs(Tr, {
        children: [
            /*#__PURE__*/ _jsx(Td, {
                whiteSpace: "nowrap",
                textAlign: "center",
                paddingX: 0,
                width: "1px",
                children: /*#__PURE__*/ _jsx(Switch, {
                    isChecked: timer.enabled,
                    onChange: handleToggleEnabled,
                    disabled: loading
                })
            }),
            /*#__PURE__*/ _jsx(Td, {
                maxW: "1px",
                minWidth: "100px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                children: /*#__PURE__*/ _jsxs(Stack, {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            fontWeight: 600,
                            isTruncated: true,
                            children: timer.name
                        }),
                        /*#__PURE__*/ _jsx(AliasResponse, {
                            response: timer.message,
                            alias: timer.alias
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Td, {
                width: "1px",
                display: {
                    base: 'none',
                    md: 'table-cell'
                },
                children: cronstrue.toString(timer.interval)
            }),
            /*#__PURE__*/ _jsx(Td, {
                width: "1px",
                whiteSpace: "nowrap",
                textAlign: "right",
                children: /*#__PURE__*/ _jsxs(ButtonGroup, {
                    spacing: 2,
                    size: "xs",
                    children: [
                        /*#__PURE__*/ _jsx(IconButton, {
                            backgroundColor: "backgroundPrimary",
                            "aria-label": intl.formatMessage({
                                id: "gs33Q2",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Edit Timer"
                                    }
                                ]
                            }),
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faPencil
                            }),
                            onClick: onEdit
                        }),
                        /*#__PURE__*/ _jsx(IconButton, {
                            backgroundColor: "backgroundPrimary",
                            "aria-label": intl.formatMessage({
                                id: "aWPmCi",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Delete Timer"
                                    }
                                ]
                            }),
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faTrash
                            }),
                            onClick: onDelete
                        })
                    ]
                })
            })
        ]
    });
}
var MemoizedTimerRow = /*#__PURE__*/ React.memo(TimerRow, function(prev, next) {
    var _prev_channel, _next_channel;
    return prev.timer._id === next.timer._id && prev.timer.enabled === next.timer.enabled && prev.timer.alias === next.timer.alias && prev.timer.interval === next.timer.interval && prev.timer.message === next.timer.message && ((_prev_channel = prev.channel) === null || _prev_channel === void 0 ? void 0 : _prev_channel._id) === ((_next_channel = next.channel) === null || _next_channel === void 0 ? void 0 : _next_channel._id) && prev.onEdit === next.onEdit && prev.onDelete === next.onDelete;
});
function Timers() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(null), 2), selectedTimerId = _React_useState[0], setSelectedTimerId = _React_useState[1];
    var _useTimerStore = useTimerStore(useShallow(function(state) {
        return {
            timers: channel != null ? state.getTimersForChannel(channel._id) : null,
            isLoading: state.isLoading
        };
    })), timers = _useTimerStore.timers, isLoading = _useTimerStore.isLoading;
    var deleteTimerModal = useDisclosure();
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(), 2), sortDirection = _useSortDirectionQueryState[0], setSortDirection = _useSortDirectionQueryState[1];
    var _useQueryState = _sliced_to_array(useQueryState('sortBy', {
        defaultValue: "name"
    }), 2), sortBy = _useQueryState[0], setSortBy = _useQueryState[1];
    var _usePageQueryState = _sliced_to_array(usePageQueryState(), 2), page = _usePageQueryState[0], setPage = _usePageQueryState[1];
    var _useLimitQueryState = _sliced_to_array(useLimitQueryState(), 2), limit = _useLimitQueryState[0], setLimit = _useLimitQueryState[1];
    var _useSearchQueryState = _sliced_to_array(useSearchQueryState(), 2), search = _useSearchQueryState[0], setSearch = _useSearchQueryState[1];
    var _useDebounce = _sliced_to_array(useDebounce(search, 500), 1), debouncedSearch = _useDebounce[0];
    var sortedTimers = React.useMemo(function() {
        var sortedTimers = timers;
        if (sortedTimers == null) {
            return null;
        }
        if (debouncedSearch.length > 0) {
            var normalizedQuery = debouncedSearch.toLowerCase();
            sortedTimers = sortedTimers.filter(function(timer) {
                return timer.name.toLowerCase().includes(normalizedQuery) || timer.message.toLowerCase().includes(normalizedQuery);
            });
        }
        var sortFn = sortBy != null ? SortFunctions[sortBy] : null;
        if (sortFn == null) {
            return sortedTimers;
        }
        sortedTimers = _to_consumable_array(sortedTimers);
        return sortDirection === SortDirections.ASC ? sortedTimers.sort(sortFn) : sortedTimers.sort(function(a, b) {
            return -sortFn(a, b);
        });
    }, [
        timers,
        debouncedSearch,
        sortDirection,
        sortBy
    ]);
    var handleDelete = React.useCallback(function(timerId) {
        setSelectedTimerId(timerId);
        deleteTimerModal.onOpen();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        deleteTimerModal.onOpen
    ]);
    var handleEdit = React.useCallback(function(timerId) {
        navigate(DynamicWebRoutes.TIMERS_EDIT(timerId));
    }, [
        navigate
    ]);
    function handleConfirmDelete() {
        return _handleConfirmDelete.apply(this, arguments);
    }
    function _handleConfirmDelete() {
        _handleConfirmDelete = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (selectedTimerId == null || channel == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            deleteTimer(channel._id, selectedTimerId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleConfirmDelete.apply(this, arguments);
    }
    React.useEffect(function() {
        if (isLoading || channel == null) {
            return;
        }
        getTimers(channel._id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel
    ]);
    var slicedTimers = React.useMemo(function() {
        if (sortedTimers == null) {
            return null;
        }
        return sortedTimers.slice(page * limit, (page + 1) * limit);
    }, [
        sortedTimers,
        page,
        limit
    ]);
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "q5NYii",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Timers"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "zMP4Ts",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Timers are messages that are sent at regular intervals."
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "q5NYii",
                    defaultMessage: "Timers"
                })
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                children: [
                    /*#__PURE__*/ _jsx(SearchInput, {
                        search: search,
                        setSearch: setSearch,
                        placeholder: intl.formatMessage({
                            id: "/a/wmC",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Search timers..."
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(ButtonGroup, {
                        size: "sm",
                        ml: "auto",
                        variant: "cta",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                onClick: function() {
                                    return navigate(WebRoutes.TIMERS_CREATE);
                                },
                                display: {
                                    base: 'none',
                                    sm: 'block'
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "JhBE/L",
                                    defaultMessage: "New Timer"
                                })
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                display: {
                                    base: 'block',
                                    sm: 'none'
                                },
                                onClick: function() {
                                    return navigate(WebRoutes.TIMERS_CREATE);
                                },
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faPlus
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "2xN+AO",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "New Command"
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: slicedTimers,
                extraData: [
                    channel === null || channel === void 0 ? void 0 : channel._id,
                    page,
                    limit,
                    sortDirection,
                    sortBy,
                    navigate,
                    handleDelete,
                    handleEdit
                ],
                renderFooter: function() {
                    var _sortedTimers_length;
                    return /*#__PURE__*/ _jsx(Pagination, {
                        limit: limit,
                        page: page,
                        setLimit: setLimit,
                        total: (_sortedTimers_length = sortedTimers === null || sortedTimers === void 0 ? void 0 : sortedTimers.length) !== null && _sortedTimers_length !== void 0 ? _sortedTimers_length : 0,
                        nextPage: function() {
                            return setPage(page + 1);
                        },
                        previousPage: function() {
                            return setPage(page - 1);
                        }
                    });
                },
                renderHeader: function() {
                    return /*#__PURE__*/ _jsx(MemoizedTimerHeader, {
                        sortBy: sortBy,
                        sortDirection: sortDirection,
                        setSortDirection: setSortDirection,
                        setSortBy: setSortBy
                    });
                },
                renderEmptyState: function() {
                    return /*#__PURE__*/ _jsx(EmptyState, {
                        title: intl.formatMessage({
                            id: "JNS2fT",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "No Timers"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "q5y1vd",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Timers are messages that are sent at regular intervals. Start by creating a new timer."
                                }
                            ]
                        }),
                        icon: /*#__PURE__*/ _jsx(Alarm, {
                            size: LordIconSizes.MEDIUM
                        }),
                        buttons: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "cta",
                                onClick: function() {
                                    return navigate(WebRoutes.TIMERS_CREATE);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "JhBE/L",
                                    defaultMessage: "New Timer"
                                })
                            }, "new-timer")
                        ]
                    });
                },
                renderRow: function(timer) {
                    return /*#__PURE__*/ _jsx(MemoizedTimerRow, {
                        channel: channel,
                        timer: timer,
                        onDelete: handleDelete,
                        onEdit: handleEdit
                    });
                }
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                title: intl.formatMessage({
                    id: "aWPmCi",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Timer"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "1H9iE7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this timer?"
                        }
                    ]
                }),
                isOpen: deleteTimerModal.isOpen,
                onClose: deleteTimerModal.onClose,
                submitText: intl.formatMessage({
                    id: "aWPmCi",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Timer"
                        }
                    ]
                }),
                onSubmit: handleConfirmDelete
            })
        ]
    });
}
export default Timers;
